import {
  GroupFragment,
  IdentityFragment,
  getError,
  getTypeOrNull,
  useCurrentUserGroupsQuery,
} from '@spotify/confidence-graphql';

const identityNameFromGroup = (group: GroupFragment) => {
  // this is a hack to get the identity name.
  // the identity name for groups is 'identity/g{groupId}'
  return group.name.replace('groups/', 'identities/g');
};

const isNotNull = <T>(value: T | null | undefined): value is T =>
  value !== null && value !== undefined;

export function useCurrentUserGroups(options?: { skip?: boolean }) {
  const {
    loading,
    data,
    error: networkError,
  } = useCurrentUserGroupsQuery({
    fetchPolicy: 'cache-first',
    skip: options?.skip,
  });

  const userGroups = getTypeOrNull(data?.currentUser)?.user?.userGroups;
  const appError = getError(data?.currentUser);

  const groups: GroupFragment[] =
    getTypeOrNull(userGroups)
      ?.userGroups.map(ug => ug.group)
      // filter out null and undefined; and to make types more sane
      .filter(isNotNull) ?? [];

  const identities: IdentityFragment[] = groups.map(g => ({
    __typename: 'IamV1Identity',
    // this is a hack to get the identity name.
    // the identity name for groups is 'identity/g{groupId}'
    name: identityNameFromGroup(g),
    displayName: g.displayName,
    group: g,
  }));

  return {
    isLoading: loading,
    error: appError ?? networkError,
    groups,
    identities,
  };
}
